import React from 'react';
import { FileText } from 'lucide-react';

const AttachmentsEmptyState: React.FC = () => {
  return (
    <div className='text-center py-8 text-muted-foreground'>
      <FileText className='h-12 w-12 mx-auto mb-4 opacity-50' />
      <p>No attachments uploaded yet</p>
      <p className='text-sm mt-1'>
        Upload documents related to the patient's medications
      </p>
    </div>
  );
};

export default AttachmentsEmptyState;
